import EditIncentiveProgram from './edit-incentive-program.container';

export default EditIncentiveProgram